import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { SlackRegistration } from './SlackRegistration';

export const RegisterToSlackComponents: FormDrawerProps<ZodSchema<unknown>> = {
  ContentComponent: SlackRegistration,
};
